import ZoneSelectorControlBase from './ZoneSelectorControlBase';
import dom from '../../../../utils/dom';


class ZoneRadioButtonList extends ZoneSelectorControlBase {
  /**
   * @param {HTMLLIElement[]} listItems
   */
  constructor(listItems) {
    super();

    this.parentList = listItems[0].parentElement;

    this.onInputChange = this.onInputChange.bind(this);

    this.items = listItems.map((listItem) => {
      /** @type {HTMLInputElement} */
      const radio = dom.findFrom(listItem, 'input');

      return {
        listItem,
        radio,
        zoneId: radio.value,
        zoneGroupId: radio.getAttribute('data-tn-zone-group-id'),
        isSelected: false,
        isAvailable: !radio.disabled,
      };
    });

    this.items.forEach(({ radio }) =>
      radio.addEventListener('change', this.onInputChange));
  }

  onInputChange(event) {
    const zoneId = event.target.value;

    this.notifyZoneChange(zoneId);
  }

  selectZone(zoneId) {
    const item = this.getItem(zoneId);

    if (item) {
      this.deselectZoneGroupItems(item.zoneGroupId);

      item.radio.checked = true;
      item.isSelected = true;
    } else {
      this.items.forEach((radio) => {
        radio.checked = false;
      });
    }
  }

  destroy() {
    this.removeAllListeners();
    this.items.forEach(({ radio }) => {
      radio.removeEventListener('change', this.onInputChange);
    });
  }

  selectZoneGroup(zoneGroupId) {
    const { parentList } = this;

    this.items.forEach(({ listItem, zoneGroupId: itemZoneGroupId }) => {
      const isVisible = itemZoneGroupId === zoneGroupId;

      if (isVisible) {
        parentList.appendChild(listItem);
      } else {
        if (listItem.parentElement) {
          dom.remove(listItem);
        }
      }
    });
  }
}


export default ZoneRadioButtonList;



// WEBPACK FOOTER //
// ./src/events/detail/zoneSelector/controls/ZoneRadioButtonList.js